import { render, staticRenderFns } from "./EditResize.vue?vue&type=template&id=a344f108&"
import script from "./EditResize.vue?vue&type=script&lang=js&"
export * from "./EditResize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditResize.vue"
export default component.exports